import logger from '../lib/utils/logger'
export default {
  destroyed () {
    logger.debug('Component [' + this.$options.name + '] destroyed')
  }
}



// WEBPACK FOOTER //
// ./src/mixins/destroyed.js